// client/globals/methods.ts
import { A } from "@adornis/base/env-info.js";
import { nothing } from "lit";
import "../extensions/x-extension-editor.js";
import { ExtensionType } from "./enums.js";
var deepCopyBaseArray = ({ content, extensions }) => {
  const copiedValues = /* @__PURE__ */ new Map();
  const subitemMap = /* @__PURE__ */ new Map();
  for (const base of content) {
    try {
      base.subItemID;
    } catch {
      base.subItemID = null;
    }
    const baseCopy = copyContent({
      extensions,
      content: [],
      instanceToCopy: base
    });
    if (baseCopy && "items" in baseCopy && Array.isArray(baseCopy.items) && base && "items" in base && Array.isArray(base.items)) {
      for (const [index, item] of baseCopy.items.entries()) {
        subitemMap.set(base.items[index]._id, item._id);
      }
    }
    if (baseCopy && "accordeonItems" in baseCopy && Array.isArray(baseCopy.accordeonItems) && base && "accordeonItems" in base && Array.isArray(base.accordeonItems)) {
      for (const [index, item] of baseCopy.accordeonItems.entries()) {
        subitemMap.set(base.accordeonItems[index]._id, item._id);
      }
    }
    copiedValues.set(base._id, baseCopy);
  }
  for (const value of copiedValues.values()) {
    if (value.parentID) {
      const parent = copiedValues.get(value.parentID);
      if (parent)
        value.parentID = parent._id;
    }
    if (value.subItemID) {
      const subitemID = subitemMap.get(value.subItemID);
      if (subitemID)
        value.subItemID = subitemID;
    }
  }
  return Array.from(copiedValues.values());
};
var __renderBase = (extensions, content, { defaultValues, isSubelement = false } = {}) => {
  if (!content)
    return;
  const extension = getExtensionForData(content, extensions);
  if (!extension)
    return nothing;
  return extension.render(content, { defaultValues, isSubelement });
};
function copyClipboardContent({
  extensions,
  content,
  contentID
}) {
  if (!extensions || !content)
    throw new Error("no extensions or content was given in copyClipboardContent");
  const index = content.findIndex((base) => {
    return base._id === contentID;
  });
  if (index === -1)
    throw new Error("index not found");
  const data = content[index];
  if (!data)
    throw new Error("content not found");
  const dataToCopy = [];
  dataToCopy.push(data);
  const copyChildren = (parent) => {
    const children = content.filter((item) => item.parentID === parent._id);
    for (const child of children) {
      children.push(...copyChildren(child));
    }
    return children;
  };
  dataToCopy.push(...copyChildren(data));
  const copiedData = deepCopyBaseArray({ content: dataToCopy, extensions });
  return copiedData;
}
function copyContent({
  extensions,
  content,
  instanceToCopy
}) {
  if (!extensions || !content)
    throw new Error("no extensions or content was given in copyContent");
  const extension = getExtensionForData(instanceToCopy, extensions);
  const newInstance = new extension.class({
    ...changeIDInNestedJSON(instanceToCopy.toJSON()),
    _id: A.getGloballyUniqueID()
  });
  return newInstance;
}
function changeIDInNestedJSON(jsonObj) {
  if (jsonObj && typeof jsonObj === "object") {
    for (const key in jsonObj) {
      if (jsonObj.hasOwnProperty(key)) {
        if (key === "_id") {
          jsonObj[key] = A.getGloballyUniqueID();
        } else if (typeof jsonObj[key] === "object") {
          jsonObj[key] = changeIDInNestedJSON(jsonObj[key]);
        }
      }
    }
  }
  return jsonObj;
}
var isBuildifyContentExtension = (data) => {
  return data && (!data.type || data.type === ExtensionType.CONTENT);
};
var getExtensionForData = (data, extensions) => {
  if (!extensions)
    throw new Error("no context-value for extensions found");
  if (!data)
    throw new Error("no content set");
  const extension = extensions.find((e) => e.class._class === data._class);
  if (!extension) {
    throw new Error(`extension for class '${data._class}' not found`);
  }
  return extension;
};
var convertDataBySize = (data, extension, size) => {
  const filteredConfigsBySize = data.configs.filter((config) => config.size === size);
  const convertedContent = new extension.class({ ...data.toObject() });
  for (const config of filteredConfigsBySize) {
    let changeValue = convertedContent;
    for (let [index, key] of config.keyArray.entries()) {
      let parsedKey = key;
      const keyNumberParsed = Number.parseInt(key);
      if (!Number.isNaN(keyNumberParsed)) {
        parsedKey = keyNumberParsed;
      }
      if (index === config.keyArray.length - 1) {
        changeValue[parsedKey] = config.value;
      } else {
        changeValue = changeValue[parsedKey];
      }
    }
  }
  Object.freeze(convertedContent);
  return convertedContent;
};
export {
  __renderBase,
  convertDataBySize,
  copyClipboardContent,
  copyContent,
  deepCopyBaseArray,
  getExtensionForData,
  isBuildifyContentExtension
};
